import React, { useMemo, memo } from "react";
import { ResponsiveLine } from "@nivo/line";

import { usePlpPriceHistory } from "domain/stats/useGlpStats";
import { convertPriceToChartData, formatXAxis, getTooltipDay } from "./helpers/generateChartData";

const CustomPoint = (props) => {
  const { currentSlice } = props;

  if (currentSlice) {
    return (
      <g>
        <circle
          r={4}
          strokeWidth={"1"}
          stroke={"#7993D0"}
          fill={"#7993D0"}
          fillOpacity={0.85}
          cx={currentSlice.points[0].x}
          cy={currentSlice.points[0].y}
        />
      </g>
    );
  }
};

const line1Color = "#7993D0";

const getColoredAxis = () => {
  return {
    axis: {
      ticks: {
        text: { fill: "#6C7284" },
      },
    },
    crosshair: {
      line: {
        stroke: "#FFFFFF",
        strokeWidth: 1,
        strokeOpacity: 0.06,
      },
    },
  };
};

const Chart = ({ interval, setPriceFromChart }) => {
  const { plpPriceStory } = usePlpPriceHistory();
  const data = useMemo(() => convertPriceToChartData(plpPriceStory, interval), [plpPriceStory, interval]);

  return (
    <ResponsiveLine
      data={data}
      layers={["markers", "axes", "areas", "crosshair", "lines", "slices", "mesh", CustomPoint]}
      colors={[line1Color]}
      theme={getColoredAxis(line1Color)}
      margin={{ top: 5, right: 30, bottom: 35, left: 30 }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false
      }}
      areaBaselineValue={100}
      useMesh
      isInteractive
      axisLeft={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 20,
        format: (value) => {
          return formatXAxis(value, interval, data[0]?.data.length);
        },
      }}
      enableSlices="x"
      enableArea
      defs={[
        {
          id: "gradientC",
          type: "linearGradient",
          colors: [
            { offset: 0, color: "#7993D0" },
            { offset: 8, color: "rgba(0, 0, 0, 0)" },
          ],
        },
      ]}
      fill={[{ match: "*", id: "gradientC" }]}
      sliceTooltip={({ slice }) => {
        const hoveredDataItem = data[0]?.data.find(({ x }) => x === slice.points[0].data.x);
        setPriceFromChart(hoveredDataItem.y);
        return (
          <div className="text-inactive text-[1.2rem]">
            <div>{getTooltipDay(slice.points[0].data.x, interval)}</div>
          </div>
        );
      }}
    />
  );
};

export default memo(Chart);
